import React from 'react';
import { Svg, Path } from 'react-native-svg';

import styles from './index.module.scss';

const FreeShippingIcon = ({ color = '#000' }) => {
    return (
        <Svg
            className={styles.freeShippingIcon}
            viewBox="0 0 40 40"
            xmlns="http://www.w3.org/2000/svg"
        >
            <Path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21.5581 10.3333L11.9809 10.3337C11.0994 10.3337 10.3848 11.0799 10.3848 12.0004V15.3332H7.1924V12.0004C7.1924 9.23903 9.33622 7.0005 11.9808 7.00038L21.5579 7C24.2027 6.99988 26.3467 9.23842 26.3467 11.9999H30.3373L35.924 19.7776V30.3339H29.5392V27.0006H32.7315V21.9999H26.3467V25.3332H23.1544V12C23.1544 11.0795 22.4397 10.3333 21.5581 10.3333ZM26.3467 18.6666H31.1354L28.7411 15.3332H26.3467V18.6666ZM10.3848 27.0006V23.6666H7.1924V30.3339H11.981V27.0006H10.3848ZM18.3658 26.9999H23.1544V30.3332H18.3658V26.9999Z"
                fill={color}
            />
            <Path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.1734 30.3339C16.0549 30.3339 16.7696 29.5877 16.7696 28.6672C16.7696 27.7467 16.0549 27.0006 15.1734 27.0006C14.2918 27.0006 13.5772 27.7467 13.5772 28.6672C13.5772 29.5877 14.2918 30.3339 15.1734 30.3339ZM15.1734 33.6672C17.8181 33.6672 19.9619 31.4286 19.9619 28.6672C19.9619 25.9057 17.8181 23.6672 15.1734 23.6672C12.5287 23.6672 10.3848 25.9057 10.3848 28.6672C10.3848 31.4286 12.5287 33.6672 15.1734 33.6672Z"
                fill={color}
            />
            <Path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M26.3467 30.3339C27.2283 30.3339 27.9431 29.5877 27.9431 28.6672C27.9431 27.7467 27.2283 27.0006 26.3467 27.0006C25.4653 27.0006 24.7506 27.7467 24.7506 28.6672C24.7506 29.5877 25.4653 30.3339 26.3467 30.3339ZM26.3467 33.6672C28.9915 33.6672 31.1354 31.4286 31.1354 28.6672C31.1354 25.9057 28.9915 23.6672 26.3467 23.6672C23.7021 23.6672 21.5583 25.9057 21.5583 28.6672C21.5583 31.4286 23.7021 33.6672 26.3467 33.6672Z"
                fill={color}
            />
            <Path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.1734 17.0006H4V13.6672H15.1734V17.0006Z"
                fill="#333333"
            />
            <Path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.7696 22.0006H5.59621V18.6672H16.7696V22.0006Z"
                fill="#333333"
            />
        </Svg>
    );
};
export default FreeShippingIcon;
